/**
 * Tools guide — assigning tools, 3rd party integrations, and end-user OAuth.
 */

import { createFileRoute } from "@tanstack/react-router";
import { DocsPage } from "@/components/docs/docs-page";
import { skillsContent } from "@/constants/docs/skills";

export const Route = createFileRoute("/docs/skills")({
	component: ToolsPage,
});

function ToolsPage() {
	return <DocsPage title="Tools" content={skillsContent} />;
}
